export default "__VITE_ASSET__Cx$1JxFY__"